import { z } from 'zod';
/**
 * "Sua IA" (estudo 12/10/2026, fases 1 e 2 aprovadas): a pessoa do plano Completo conecta a
 * própria conta de IA por chave de API. Texto, documentos, apresentações e pesquisa passam a
 * usar a IA dela (sem contar nos pedidos do plano), com a nossa de reserva; com a chave do
 * Google, também a conversa ao vivo (sem contar nos minutos). Nunca login ou sessão de
 * assinatura (Claude Pro, Google AI Pro): só chave de API, como as empresas permitem.
 */
export const MY_AI_PROVIDERS = ['gemini', 'openai', 'anthropic', 'openrouter'];
export const myAiProviderSchema = z.enum(MY_AI_PROVIDERS);
export const MY_AI_INFO = {
    gemini: {
        name: 'Google Gemini',
        keyUrl: 'https://aistudio.google.com/apikey',
        keyPrefix: 'AI',
        model: 'gemini-3.8-flash',
        models: ['gemini-3.8-flash', 'gemini-3.1-pro-preview', 'gemini-3.5-flash-lite'],
        voice: true,
    },
    openai: {
        name: 'OpenAI (ChatGPT)',
        keyUrl: 'https://platform.openai.com/api-keys',
        keyPrefix: 'sk-',
        model: 'gpt-5.4-mini',
        models: ['gpt-5.4-mini', 'gpt-6-sol'],
        voice: false,
    },
    anthropic: {
        name: 'Anthropic (Claude)',
        keyUrl: 'https://platform.claude.com/settings/keys',
        keyPrefix: 'sk-ant-',
        model: 'claude-haiku-5-5',
        models: ['claude-haiku-5-5', 'claude-sonnet-5-5'],
        voice: false,
    },
    openrouter: {
        name: 'OpenRouter',
        keyUrl: 'https://openrouter.ai/settings/keys',
        keyPrefix: 'sk-or-',
        model: 'openai/gpt-5-mini',
        models: ['openai/gpt-5-mini', 'anthropic/claude-sonnet-5.5', 'google/gemini-3.8-flash'],
        voice: false,
    },
};
const modelName = z
    .string()
    .trim()
    .min(2)
    .max(80)
    .regex(/^[\w.\-/:@]+$/, 'Nome de modelo inválido.');
export const myAiConnectSchema = z.object({
    provider: myAiProviderSchema,
    key: z.string().trim().min(16).max(400),
    model: modelName.optional(),
    /** Gemini: a pessoa leu o aviso de que a chave grátis do Google treina com os dados. */
    freeTierOk: z.boolean().optional(),
});
export const myAiPatchSchema = z.object({
    model: modelName.optional(),
    /** Usar também na conversa ao vivo (só Gemini). */
    voice: z.boolean().optional(),
    /** Pausar sem desconectar. */
    enabled: z.boolean().optional(),
});
export const myAiStatusSchema = z.object({
    /** O plano permite (Completo). */
    allowed: z.boolean(),
    connected: z.boolean(),
    provider: myAiProviderSchema.nullable(),
    model: z.string().nullable(),
    /** Os quatro últimos caracteres, para a pessoa reconhecer a chave. */
    keyHint: z.string().nullable(),
    enabled: z.boolean(),
    voice: z.boolean(),
    /** Última conferência que deu certo. */
    testedAt: z.iso.datetime({ offset: true }).nullable(),
    /** O que deu errado na última tentativa, em frase para a pessoa. */
    problem: z.string().nullable(),
    /** Respostas da IA dela neste mês (texto e documentos) e minutos de voz. */
    monthRequests: z.number().int().nonnegative(),
    monthVoiceMinutes: z.number().int().nonnegative(),
});
